@for (line of lines(); track $index) {
<wm-front-skeleton-line></wm-front-skeleton-line>
}
